import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Dimmer, Loader, Pagination, Table } from 'semantic-ui-react';
import { getOutletLogsAction } from 'state/business/actions';
import { formatLocalDateTime } from 'utils/dateTimeUtils';
import { SemanticToastContainer } from 'react-semantic-toasts';
import styles from './OutletActivityLogs.module.css';

const OutletActivityLogs = props => {
  const { loadingOutletLogs, allBusiness, outletLogs, dispatch } = props;

  useEffect(() => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    const payload = {
      businessId,
      size: 10,
      page: 1,
    };
    dispatch(getOutletLogsAction(payload));
  }, [allBusiness.activeIndex, allBusiness.data, dispatch]);

  const { data, paging } = outletLogs;
  const size = 10;
  let totalPages = 1;
  if (paging) totalPages = Math.ceil(paging.total / size);

  const handleOnPageChange = (_, val) => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    const { activePage } = val;
    const payload = {
      businessId,
      size: 10,
      page: activePage,
    };
    dispatch(getOutletLogsAction(payload));
  };

  const toLocalDatetime = dateString => {
    const date = new Date(dateString);
    return formatLocalDateTime(date);
  };

  return (
    <>
      <SemanticToastContainer />
      <Dimmer active={loadingOutletLogs}>
        <Loader size="massive">Loading</Loader>
      </Dimmer>
      <div className={styles['logs-table']}>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={4}>Time</Table.HeaderCell>
              <Table.HeaderCell width={8}>Logs</Table.HeaderCell>
              <Table.HeaderCell width={4}>Reason</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data ? (
              data.internal_tools_activities.map(logs => {
                return (
                  <Table.Row>
                    <Table.Cell>{toLocalDatetime(logs.time)}</Table.Cell>
                    <Table.Cell>{logs.log}</Table.Cell>
                    <Table.Cell>{logs.reason}</Table.Cell>
                  </Table.Row>
                );
              })
            ) : (
              <></>
            )}
          </Table.Body>
          {paging ? (
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell colSpan="7">
                  <Pagination
                    activePage={paging.page}
                    totalPages={totalPages}
                    onPageChange={handleOnPageChange}
                    size="mini"
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          ) : (
            <></>
          )}
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = ({ business }) => ({
  outletLogs: business.outletLogs,
  allBusiness: business.allBusiness,
  loadingOutletLogs: business.loadingOutletLogs,
});

OutletActivityLogs.propTypes = {
  dispatch: PropTypes.func.isRequired,
  outletLogs: PropTypes.object.isRequired,
  allBusiness: PropTypes.object.isRequired,
  loadingOutletLogs: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(OutletActivityLogs);
